import { Card, Group, Stack, Text } from '@mantine/core';

import type { CardHeaderViewProps } from './CardHeader.types';

export function CardHeaderView({
  icon,
  title,
  description,
  badge,
  actions,
  withDivider = true,
  padding = 'md',
}: CardHeaderViewProps) {
  if (!icon && !title && !description && !actions && !badge) return null;

  return (
    <Card.Section withBorder={withDivider} px={padding} py="md" mb="md">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="xs" align="center" wrap="nowrap" style={{ minWidth: 0, flex: 1 }}>
          {icon}
          <Stack gap={2} style={{ minWidth: 0, flex: 1 }}>
            <Group gap="xs" wrap="nowrap">
              {title &&
                (typeof title === 'string' ? (
                  <Text fw={600} size="sm">
                    {title}
                  </Text>
                ) : (
                  title
                ))}
              {badge}
            </Group>
            {description &&
              (typeof description === 'string' ? (
                <Text size="xs" c="dimmed">
                  {description}
                </Text>
              ) : (
                description
              ))}
          </Stack>
        </Group>
        {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
      </Group>
    </Card.Section>
  );
}
